import axios from 'axios';

const CAMPAIGN_API = 'https://influencers.dyzio.co/api/v2/campaign';
const VIDEO_API = 'https://influencers.dyzio.co/api/v2/video';
const INFLUENCER_PROFILE_API = 'https://influencers.dyzio.co/influencerprofiles';
const VIDEOS_API = 'https://influencers.dyzio.co/api/v2/videos';

export function getVideoListAnalytics(youtubeVideoIds) {

  let videoListString = '';
  youtubeVideoIds.forEach(id => videoListString += `${id},`);

  if (videoListString) {
    videoListString = videoListString.slice(0, -1); // Remove last comma

    const endpoint = `${VIDEOS_API}/${videoListString}`;
    const payload = {

      validateStatus: function (status) {
        return status >= 200 && status < 300 && status !== 404;
      }
    };
    const headers = {};

    return axios.get(endpoint, payload, headers)
      .then(response => {
        return response.data.videos;
      });
  }
}

export function getVideoHistory(videoId){

  const endpoint = `${VIDEO_API}/${videoId}`;
  const payload = {

    validateStatus: function (status) {
      return status >= 200 && status < 300 && status !== 404;
    }
  };
  const headers = {};

  return axios.get(endpoint, payload, headers)
    .then(response => {
      return response.data.video;
    });
}

export function getInfluencerProfile(influencerId){

  const endpoint = `${INFLUENCER_PROFILE_API}/${influencerId}`;
  const payload = {};
  const headers = {};

  return axios.get(endpoint, payload, headers)
    .then(response => {
      return response.data.influencer;
    });
}



/** WEBPACK FOOTER **
 ** ./src/utils/analytics-service.js
 **/